<template>
  <button class="uk-button uk-button-text" @click="logoutWhenConfirmed">
    <icon class="uk-margin-small-right" name="sign-out" />
      Logout
  </button>
</template>

<script>
import UIkit from 'uikit';
import { signOut } from '@/common/auth';

export default {
  name: 'logout-button',
  methods: {
    redirectToLogin() {
      this.$router.push({ name: 'login' });
    },
    logoutWhenConfirmed() {
      const message = this.$t('confirmations.logout');
      UIkit.modal
           .confirm(message)
           .then(() => { signOut(); })
           .catch(() => {});
    },
  },
  i18n: {
    messages: {
      de: {
        confirmations: {
          logout: 'Möchtest du dich wirklich ausloggen?',
        },
        toasts: {
          signedOut: 'Bis bald, {name}!',
          error: 'Da lief was schief!',
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// LogoutButton.vue?30bfb016